/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Wealthlane_Shared_Hosting_Enums_SandboxInitializationType {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}
